import { t } from 'translation';

export const unexpectedErrorPhrases = {
  somethingWentWrong: t('errors.somethingWentWrong'),
  walletNotConnected: t('errors.walletNotConnected'),
  undefinedAccountErrorMessage: t('errors.undefinedAccountErrorMessage'),
  internalErrorBrnToVrtConversionRatioUndefined: t(
    'convertVrt.internalErrorBrnToVrtConversionRatioUndefined',
  ),
  accountError: t('markets.errors.accountError'),
};
